var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        {
          attrs: { left: "", color: "transparent" },
          model: {
            value: _vm.tabModel,
            callback: function($$v) {
              _vm.tabModel = $$v
            },
            expression: "tabModel"
          }
        },
        [_c("v-tab", { attrs: { href: "#tab-2" } }, [_vm._v("Ramplas")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "0px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { sm10: "", md10: "", layout: "", wrap: "" } },
            [
              _c(
                "v-flex",
                { attrs: { "sm2.5": "", "md2.5": "" } },
                [
                  _c("DateComponent", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "tfClass",
                    attrs: {
                      label: _vm.formFields.dateStart.label,
                      "data-vv-name": "fechaFinRequerida",
                      "error-messages": _vm.errors.collect("fechaFinRequerida"),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateStart.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateStart, "value", $$v)
                      },
                      expression: "formFields.dateStart.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { "sm2.5": "", "md2.5": "" } },
                [
                  _c("TimeComponent", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "tfClass",
                    attrs: {
                      label: _vm.formFields.timeStart.label,
                      "data-vv-name": "horaFinRequerida",
                      "error-messages": _vm.errors.collect("horaFinRequerida"),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.timeStart.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.timeStart, "value", $$v)
                      },
                      expression: "formFields.timeStart.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { "sm2.5": "", "md2.5": "" } },
                [
                  _c("DateComponent", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "tfClass",
                    attrs: {
                      label: _vm.formFields.dateEnd.label,
                      "data-vv-name": "fechaFinRequerida",
                      "error-messages": _vm.errors.collect("fechaFinRequerida"),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.dateEnd.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                      },
                      expression: "formFields.dateEnd.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { "sm2.5": "", "md2.5": "" } },
                [
                  _c("TimeComponent", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "tfClass",
                    attrs: {
                      label: _vm.formFields.timeEnd.label,
                      "data-vv-name": "horaFinRequerida",
                      "error-messages": _vm.errors.collect("horaFinRequerida"),
                      required: ""
                    },
                    model: {
                      value: _vm.formFields.timeEnd.value,
                      callback: function($$v) {
                        _vm.$set(_vm.formFields.timeEnd, "value", $$v)
                      },
                      expression: "formFields.timeEnd.value"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "align-items": "center"
                  },
                  attrs: { "sm2.5": "", "md2.5": "" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-xs-center" },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", icon: "", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.filter_pareo()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("search")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", icon: "", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.reset_filters()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("clear")])],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "0px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
            _c(
              "div",
              { attrs: { align: "left" } },
              [
                _c("v-text-field", {
                  attrs: {
                    "append-icon": "search",
                    label: "Buscar...",
                    "single-line": "",
                    "hide-details": ""
                  },
                  on: { input: _vm.onFilterTextBoxChanged },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                })
              ],
              1
            )
          ]),
          _c("v-flex", { attrs: { xs12: "", sm6: "" } }, [
            _c(
              "div",
              {
                staticStyle: { "padding-top": "15px" },
                attrs: { align: "right" }
              },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      id: "btnExportCsv",
                      flat: "",
                      small: "",
                      color: "primary"
                    },
                    on: { click: _vm.onBtnExport }
                  },
                  [
                    _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                      _vm._v("cloud_download")
                    ]),
                    _vm._v("  \n          "),
                    _c("span", { staticClass: "importExportBtnTexto" }, [
                      _vm._v("Exportar"),
                      _c("br"),
                      _vm._v("CSV")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { attrs: { id: "gridContainer" } },
        [
          _c(
            "v-card",
            { staticStyle: { width: "100%", height: "100%" } },
            [
              _c("GridComponent", {
                ref: "gridComponent",
                staticClass: "ag-theme-material",
                attrs: { id: "gridComponent", gridOptions: _vm.gridOptions }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogEliminar,
          titulo: _vm.tituloEliminar,
          mensaje: _vm.mensajeEliminar,
          textoBtnSi: _vm.$t("mensajes.crud.eliminar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.eliminar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.deleteItemCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }